import { useEffect, useState } from "react";
import axiosInstance from "../../api/axios";
import toast from "react-hot-toast";
import CatalogUploader from "../../components/catalog-uploader/CatalogUploader";
import { Loader2 } from "lucide-react";

export default function Catalog() {
    const [catalogs, setCatalogs] = useState({ fa: null, en: null });
    const [loading, setLoading] = useState(false);

    const fetchCatalogs = async () => {
        setLoading(true);
        try {
            const [faRes, enRes] = await Promise.allSettled([
                axiosInstance.get("/api/catalog/get-list-admin", { params: { is_english: false } }),
                axiosInstance.get("/api/catalog/get-list-admin", { params: { is_english: true } }),
            ]);

            setCatalogs({
                fa:
                    faRes.status === "fulfilled" && faRes.value.data?.data[0]
                        ? faRes.value.data.data[0]
                        : null,
                en:
                    enRes.status === "fulfilled" && enRes.value.data?.data[0]
                        ? enRes.value.data.data[0]
                        : null,
            });
        } catch (err) {
            toast.error("خطا در دریافت اطلاعات کاتالوگ‌ها");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchCatalogs();
    }, []);

    if (loading)
        return (
            <div className="flex justify-center items-center gap-1.5 h-[60vh] text-background">
                <Loader2 strokeWidth={1.5} className="text-black/70 animate-spin mr-2" />
                در حال دریافت اطلاعات...
            </div>
        );

    return (
       <section className="w-full flex flex-col justify-start items-start gap-6 max-w-4xl mx-auto">
            <h2 className="text-xl font-semibold text-background py-3">مدیریت کاتالوگ‌ها</h2>

            <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-6">
                <CatalogUploader
                    title="کاتالوگ فارسی"
                    catalog={catalogs.fa}
                    isEnglish={false}
                    onChange={fetchCatalogs}
                />
                <CatalogUploader
                    title="کاتالوگ انگلیسی"
                    catalog={catalogs.en}
                    isEnglish={true}
                    onChange={fetchCatalogs}
                />
            </div>
        </section>
    );
}